export function getAllLegalItems(axiosPrivate) {
  return axiosPrivate.get('/legal-tina')
}

export function getLegalItemById(axiosPrivate, uniqueCode) {
  return axiosPrivate.get(`/legal-tina/${uniqueCode}`)
}

export function createLegalItem(axiosPrivate, data) {
  return axiosPrivate.post('/legal-tina', data)
}

export function updateLegalItemById(axiosPrivate, id, data) {
  return axiosPrivate.put(`/legal-tina/${id}/update`, data)
}

export function deleteLegalItem(axiosPrivate, id) {
  return axiosPrivate.delete(`/legal-tina/${id}/delete`)
}

export function getAllLegalTinaParent(axiosPrivate, params) {
  return axiosPrivate.get('/legal-tina/all-parent', {params})
}
